import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAuditoria } from 'modelos/src';

@Component({
  selector: 'app-detalles-auditoria-dialog',
  templateUrl: './detalles-auditoria-dialog.component.html',
  styleUrl: './detalles-auditoria-dialog.component.scss',
  standalone: false,
})
export class DetallesAuditoriaDialogComponent {
  data = inject<IAuditoria>(MAT_DIALOG_DATA);
  dialogRef =
    inject<MatDialogRef<DetallesAuditoriaDialogComponent>>(MatDialogRef);

  cerrar(): void {
    this.dialogRef.close();
  }

  get camposEditados(): string[] {
    return Object.keys(this.data.valoresAnteriores ?? this.data.cambios ?? {});
  }
}
